import React, { useState } from 'react'
import { Button, Card, Col, Row } from 'react-bootstrap'
import ImageViewer from '../common/ImageViewer';
import VideoPlayerModal from '../common/VideoPlayerModal';

const VRGameDevelopment = () => {
    const [modalShow, setModalShow] = useState(false);
    const [imageUrl, setImageUrl] = useState(null)
    const [videoUrl, setVideoUrl] = useState(null)
    const [chooseModal, setChooseModal] = useState(null)

    const imageDiv = []

    const openVideoModal = (data) => {
        setModalShow(true)
        setChooseModal('video')
        setVideoUrl(data)

    }

    const openImageModal = (data) => {
        setModalShow(true)
        setChooseModal('image')
        setImageUrl(data)
    }

    for (let index = 0; index < 20; index++) {

        imageDiv.push(
            <Col xs={{span:6, offset:0}} md={{span:3, offset:0}} className="no-padding-x" key={index}>
                <Card.Img onClick={() => openImageModal(index)} className='img img-thumbnail game-images' src={process.env.PUBLIC_URL + "assets/vr-development/game-development/shelter-in-place-vr/images/"+index+".jpg"} />
            </Col>
        )        
    }


  return (
    <>
        <Card className='text-center no-border rounded-0 industrial-modeling-top-section container'>

            <Card.Body>
                <Card.Title className='industrial-modeling-title'>VR Game Development</Card.Title>
            </Card.Body>
            <Row className='pt-md-5 px-md-5'>
                <Col xs={{span:12, offset:0}} md={{span:6, offset:0}} className="pt-md-5 mt-md-2">
                    <Card.Title className='vr-healthcare-title'>Shelter in Place</Card.Title>
                    <Card.Text className='text-left vr-healthcare-text'>
                    Our first consumer VR game launched as “Unnamed VR” in November 2019 and was renamed “Shelter in Place” and offered as a free download at the onset of the pandemic.
                    </Card.Text>
                    
                    <Card.Text className='text-left vr-healthcare-text py-md-4 py-3'>
                    <Button className='yellow-schedule-button shelterinplacevr-button btn btn-warning'><a href="https://shelterinplacevr.com" target="_blank" rel="noreferrer"> Visit Website </a></Button>
                    </Card.Text>
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:6, offset:0}}>
                    {/* <Card className='no-border rounded-0 container healthcare-video-container'>
                        <Card.Img className='img img-thumbnail shelterinplacevr-image' src={process.env.PUBLIC_URL + "assets/vr-development/game-development/shelter-in-place-vr/images/spvr_001.png"} />
                    </Card> */}
                    <Card className='no-border rounded-0 container healthcare-video-container product-video-section' onClick={() => openVideoModal('assets/vr-development/game-development/shelter-in-place-vr/video/ShelterPlaceTrailer.mp4')}>
                    <Card.Img className='img img-thumbnail shelterinplacevr-image' src={process.env.PUBLIC_URL + "assets/vr-development/game-development/shelter-in-place-vr/images/spvr_001.jpg"} />
                            <Card.ImgOverlay className='playicon-overlay-center'>
                                <Card.Img src={process.env.PUBLIC_URL + "assets/icons/video-player.png"} />
                            </Card.ImgOverlay>

                        </Card>
                </Col>
            </Row>
            <Card.Title className='vr-healthcare-title text-center pt-md-5'>Shelter in Place</Card.Title>
            <Card.Text className='text-center industrial-environment-text '>
            Our first consumer VR game was an open-ended sandbox game in which the only goal is to explore and have fun in VR.  The setting is a large mansion with sixteen rooms.  In the “regular rooms” most objects are interactive so you can pick up, juggle, throw or place any small objects.  The vases break. The balls bounce. The drawers and cupboards open. TV remotes and DVD players work.  Then there are a number of “mini game” rooms, such as the adventure room with zip lines, giant trampolines and climbing walls; the music room, with guitar, drums, xylophone and synthesizer; the ping pong room, basketball, darts and throwing stars; archery in an old-west stockade; a shooting gallery, with laser guns and rocket launchers; a maze that reconfigures to a new pattern every time you enter; the spray-paint graffiti room and the 3d painting room, with a pallet to mix your colors; the toy room, with a building block vending machine; and much more…. Built as a cross-platform game for Oculus Rift and HTC Vive, Shelter in Place taught us how to create any type of physical interaction in VR and became the basis for our capability to create any training or immersive interactive scenario.
            </Card.Text>

            <Row className='py-md-3 px-md-4'>
                {imageDiv}
            </Row>

        </Card>

           
        {chooseModal === "video" && 
             <VideoPlayerModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                videosrc={videoUrl}
           />
        }

        {chooseModal === 'image' &&
            <ImageViewer 
                show={modalShow}
                onHide={() => setModalShow(false)}
                imagesrc={imageUrl}
                imagedir="assets/vr-development/game-development/shelter-in-place-vr/images/enlarge/"
                imagecounter={19}
                mimetype='jpg'
            />
        }

           

    </>
  )
}

export default VRGameDevelopment
